var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panels",
    {
      staticClass: "my-3",
      class: { "soli-round": _vm.$vuetify.breakpoint.smAndUp },
      attrs: { value: _vm.value },
    },
    [
      _c(
        "v-expansion-panel",
        { class: { "soli-round": _vm.$vuetify.breakpoint.smAndUp } },
        [
          _c("v-expansion-panel-header", [
            _c(
              "div",
              {
                staticClass:
                  "py-3 soli-grey text-align-start font-weight-bold text-lg flex-col flex",
              },
              [
                _vm._t("question"),
                _vm._v(" "),
                _vm.loading
                  ? _c("v-progress-linear", {
                      staticClass: "mt-4 soli-round",
                      attrs: { indeterminate: "" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.required
                  ? _c("div", { staticClass: "grey--text caption" }, [
                      _vm._v(
                        "\n                    *required\n                "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("action"),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            { staticClass: "custom-expansion-panel" },
            [
              _vm.content && !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "pa-2 pt-0 soli-grey" },
                    [_vm._t("response")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.content && !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "flex justify-start pa-6 soli-grey pt-0" },
                    [
                      _vm._v(
                        "\n                Sorry, no events found\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }